import { PLATFORMS, STATIC_PAGE_PLATFORM_NAMES } from '@/constant/common';
import { equals, head, isNotEmpty, pipe } from '@/utils/common';

export const reorderPlatforms = (a: string, b: string) => {
  const platformsOrder: string[] = [PLATFORMS.evolution, PLATFORMS.advanced, PLATFORMS.vmware, PLATFORMS.mlSpace];

  const normalize = (str: string) => str.trim().replace(',', '');
  const getIdxOfPlatforms = (str: string) => {
    const index = platformsOrder.indexOf(str);
    return !equals(index, -1) ? index : Number.MAX_SAFE_INTEGER;
  };

  const toIndex = pipe(normalize, getIdxOfPlatforms);
  return toIndex(a) - toIndex(b);
};

const parsePlatformsStr = (str: string) =>
  str
    .split(',')
    .map(el => el.trim())
    .filter(isNotEmpty);

// function for handle cases when passed str as 'Evolution, Advanced, ...'
export const getHighestPriorityPlatform = (platformName?: string) => {
  if (!platformName) return '';
  const splitByComma = parsePlatformsStr(platformName);

  if (splitByComma.length > 1) {
    return head(splitByComma.sort(reorderPlatforms)) || '';
  }

  return head(splitByComma) || '';
};

export const platformValuesOnly = (values: string[]): string[] => {
  const validPlatforms = Object.keys(STATIC_PAGE_PLATFORM_NAMES) as string[];

  return values.filter(value => validPlatforms.includes(value));
};

export type GetActualPlatformData = {
  sourcePlatform: string;
  filters: {
    platforms: string[];
    isAllSelected: boolean;
  };
  metaPlatform: string;
};

export const getActualPlatform = ({ sourcePlatform, metaPlatform, filters }: GetActualPlatformData): string => {
  const metaPlatforms = parsePlatformsStr(metaPlatform);

  const isSourceInMeta = metaPlatforms.includes(sourcePlatform);
  const isSourceInFilters = filters.platforms.includes(sourcePlatform);

  const sortedPlatformsInMeta = metaPlatforms.sort(reorderPlatforms);

  if (filters.isAllSelected && isSourceInMeta) {
    return sourcePlatform;
  }

  if (isSourceInFilters && isSourceInMeta) {
    return sourcePlatform;
  }

  const validPlatformsInMeta = sortedPlatformsInMeta.filter(platform => filters.platforms.includes(platform));

  return head(validPlatformsInMeta) || '';
};
